import {
    getAdoptedSocialStudiesPublications, getExploreSciencePublications,
    getHealthWellnessPublications, getNewSocialStudiesPublications,
    getPreKPublications, getSciencePublications, getSummerPublications
} from "@/common/publicationFilters";
import {cleanS3Images} from "@/common/utils";
const emptyPage = {id: null, filters: []};
export default {
    state: {
        publicationResources: [],
        pageResources: [],
        globalResources: [],
        supplementalProducts: [],
        physicalProducts: [],
        stateData: {
            messages: {},
            publications: [],
        },
        stateBlocks: [],
        pages: [],
        selectedState: null,
        selectedYear: null,
        selectedLanguage: "en",
        currentSchoolYear: null,
        currentPageId: null,
        publications: {
            "socialStudies": [],
            "newSocialStudies": [],
            "science": [],
            "healthWellness": [],
            "preK": [],
            "summer": [],
        },
        lastFetchTime: null,
    },
    getters: {
        /*************************
         * Publication Functions *
         *************************/
        getStatePublications(state) {
            return state.stateData.publications;
        },
        getNewSocialStudiesPublications(state) {
            return getNewSocialStudiesPublications(state.stateData.publications, state.selectedLanguage);
        },
        getAdoptedSocialStudiesPublications(state) {
           return getAdoptedSocialStudiesPublications(state.stateData.publications, state.selectedLanguage);
        },
        getSciencePublications(state)
        {
            return getSciencePublications(state.stateData.publications, state.selectedLanguage);
        },
        getExploreSciencePublications(state)
        {
            return getExploreSciencePublications(state.stateData.publications, state.selectedLanguage);
        },
        getPreKPublications(state)
        {
            return getPreKPublications(state.stateData.publications, state.selectedLanguage);
        },
        getSummerPublications(state)
        {
            return getSummerPublications(state.stateData.publications, state.selectedLanguage);
        },
        getHealthWellnessPublications(state)
        {
            return getHealthWellnessPublications(state.stateData.publications, state.selectedLanguage);
        },
        /************************
         *** Other Functions ***
         ***********************/
        getLastStateDataFetchTime(state) {
            return state.lastFetchTime;
        },
        getSelectedState(state) {
            return state.selectedState;
        },
        getSelectedLanguage(state) {
            return state.selectedLanguage;
        },
        getCurrentSchoolYear(state) {
            return state.currentSchoolYear;
        },
        getActiveSchoolYear(state) {
            // return current year unless month >= 3
            // TODO: transfer date of Mar. 15
            const TRANSFER_MONTH = 3;
            let year = new Date().getFullYear();
            let month = new Date().getMonth() + 1;

            if (month < TRANSFER_MONTH)
                return year;

            return year + 1;
        },
        showBothSchoolYears(state) {
            let month = new Date().getMonth();
            // 0 indexed, 3 = April.
            return month < 2 || month >= 9;
        },
        getPageById: (state) => (id) => {
            let page = state.pages.find(page => page.id === id);
            if (page)
                return page;

            return emptyPage;

        },
        getPageByKey: (state) => (key) => {
            let page = state.pages.find(page => page.key === key)
            if (page)
                return page;
            return emptyPage;
        }
    },
    mutations: {
        setLanguage(state, language) {
            state.selectedLanguage = language;
            console.log('Setting language to: ', language)
        },
        setPublications(state, publications) {
            state.stateData.publications = publications;
        },
        setStateData (state, stateData) {
            if (!stateData.messages)
                stateData.messages = {};

            state.stateData = stateData
        },
        setPublicationResources (state, publicationResources) {
            state.publicationResources = publicationResources;
        },
        setPageResources (state, pageResources) {
            state.pageResources = pageResources;
        },
        setGlobalResources (state, globalResources) {
            state.globalResources = globalResources;
        },
        setSupplementalProducts (state, supplementalProducts) {
            state.supplementalProducts = supplementalProducts
        },
        setSelectedState (state, selectedState) {
            state.selectedState = selectedState
        },
        setSelectedYear (state, selectedYear) {
            console.log("Setting Shopping year to: ", selectedYear)
            state.selectedYear = selectedYear;
        },
        setSchoolYear(state, schoolYear) {
            console.log("Setting school year to: ", schoolYear)
            state.currentSchoolYear = schoolYear;
        },
        setStateBlock(state, blocks) {
            state.stateBlocks = blocks;
        },
        setPages(state, pages) {
            state.pages = pages;
        },
        setPhysicalProducts(state, products) {
            state.physicalProducts = products;
        }
    },
    actions: {
        getPhysicalProducts(context) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('product/physical')
                    .then(response => {
                        context.commit('setPhysicalProducts', response.data.products);
                        resolve(response.data.products);
                    })
                    .catch(reject);
            });
        },
        async getStateData (context, {state= null, draft= 0, year = null}) {
            context.state.stateData = {messages: {}, publications: []};
            await new Promise((resolve, reject) => {
                let url = "home";
                if (state)
                    url += "/"+state;
                this._vm.axios.get(url, {params: {year: year, draft: draft, homeschool: context.rootState.homeschool.homeschoolStore ? 1 : 0}})
                .then(response => {
                    let stateData = response.data

                    stateData.publications.push({
                        id: 4426,
                        sku: 'POP',
                        thumbnail: "https://cdn.studiesweekly.com/store/pages/wellbeingPoster/WB%20Poster%20spread.png",
                        name: 'Positive Outlook Poster Pack',
                        price: 29.99,
                        subject: 'poster',
                        description: 'This Positive Outlook poster set is a great addition to any classroom. Each poster focuses on one area of behavioral health, including: developing a growth mindset, how to be a good listener, conflict resolution strategies, how to have a purposeful discussion, and developing an encouraging inner voice.',
                        title: 'Positive Outlook Poster Pack',
                        sizes: ["10\" x 15\"", "11\" x 17\"", "9 5/8\" x 14 7/8\""],
                        images: ["Conflict.png", "Conversation.png", "Effort.png", "Five%20Areas.png", "Good%20Listener.png", "Growth.png", "Self-talk.png", "Stop.png", "WB%20Poster%20spread.png"],
                    })

                    context.commit('setPages', stateData.pages || []);

                    if (stateData.schoolYear)
                        context.commit('setSchoolYear', stateData.schoolYear);

                    context.commit('setStateData', stateData);

                    context.commit('setSelectedState', stateData.state);
                    context.state.lastFetchTime = new Date().getTime();
                    if (context.state.currentPageId !== null) {
                        context.dispatch('getPublicationResources', context.state.currentPageId)
                    }
                    // TODO: if homeschool and state changed, remove items in cart 
                    resolve(response)
                })
                .catch(error => {
                    if (error.response && error.response.status !== 401) {
                        this._vm.$swal('Error', error.message, 'error')
                    }

                    reject(error)
                });
            })
        },
        getStateBlocks(context, state) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get(`state/content?state=${state}`)
                    .then((response) => {
                        context.commit('setStateBlock', response.data);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        this._vm.$swal('Error', error, 'error')
                    });
            })
        },
        getPublicationResources (context, pageId) {
            return new Promise((resolve, reject) => {

                if (!context.state.stateData.publications.length) {
                    context.state.currentPageId = pageId;
                    return;
                }

                console.log("getting publication resources...")

                let socialStudiesPublications = _.filter(context.state.stateData.publications, publication => {
                    if (publication.topic == 'Social Studies') {
                        return publication
                    }
                })

                let sciencePublications = _.filter(context.state.stateData.publications, publication => {
                    if (publication.topic == 'Science') {
                        return publication
                    }
                })

                let natSocialStudiesPublications = _.filter(context.state.stateData.publications, publication => {
                    if (publication.topic == 'National Social Studies') {
                        return publication
                    }
                })

                let wellBeingPublications = _.filter(context.state.stateData.publications, publication => {
                    if (publication.topic == 'Health Wellness' || publication.topic == 'Health-Wellness') {
                        return publication
                    }
                })

                // Tmp, need to move this and update this functino
                let summerPublications = _.filter(context.state.stateData.publications, publication => {
                    if (publication.topic == 'General Education' || publication.topic == 'General-Education') {
                        return publication;
                    }
                })
                // Tmp, need to move this and update this function
                let preKPubs = _.filter(context.state.stateData.publications, publication => {
                    if (publication.topic == 'Character Education' || publication.topic == 'Character-Education') {
                        return publication;
                    }
                })

                let socialStudiesSkus = _.map(socialStudiesPublications, 'sku')
                let scienceSkus = _.map(sciencePublications, 'sku')
                let natSocialStudiesSkus = _.map(natSocialStudiesPublications, 'sku')
                let wellBeingSkus = _.map(wellBeingPublications, 'sku')
                let summerSkus = _.map(summerPublications, 'sku')
                let prekSkus = _.map(preKPubs, 'sku')

                let skus = _.concat(socialStudiesSkus, scienceSkus, natSocialStudiesSkus, wellBeingSkus, summerSkus, prekSkus)

                if (skus.length === 0) {
                    resolve({data: {page: [], global: [], urls: []}});
                    return;
                }
                const selectedState = context.getters.getSelectedState;
                this._vm.axios.get("sku/resources/" + skus.join(','), {params: {page_id: pageId, state: selectedState}})
                .then(response => {


                    let pageResources = cleanS3Images(response.data.page);
                    let globalResources = cleanS3Images(response.data.global);
                    let publicationResources = response.data.urls;
                    _.forEach(publicationResources, items => {
                        cleanS3Images(items);
                    });

                    context.commit('setPublicationResources', publicationResources)
                    context.commit('setPageResources', pageResources)
                    context.commit('setGlobalResources', globalResources)

                    resolve(response)
                })
                .catch(error => {
                    if (error.response && error.response.status !== 401) {
                        this._vm.$swal('Error', error.message, 'error')
                    }

                    reject(error)
                })
            })
        },
        getSupplementalProducts (context, state) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get("supplemental/" + state)
                .then(response => {
                    let supplementalProducts = response.data

                    context.commit('setSupplementalProducts', supplementalProducts)

                    resolve(response)
                })
                .catch(error => {
                    if (error.response && error.response.status !== 401) {
                        this._vm.$swal('Error', error.message, 'error')
                    }

                    reject(error)
                })
            })
        },
        savePage(context, page) {
            return new Promise((resolve, reject) => {
                this._vm.axios.post('pages', page)
                    .then(resolve)
                    .catch(reject);
            })
        },
        getPages(context, state) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('pages', {params: {state: state}})
                    .then((response) => {
                        context.commit('setPages', response.data);
                        resolve(response.data);
                    })
                    .catch(reject);
            })
        },
        getPageBlocks(context, {state, pageId}) {
            let params = {
                state: state,
                store: context.getters.isHomeschoolStore ? "homeschool" : "school",
            }
            return new Promise((resolve, reject) => {
                this._vm.axios.get('pages/content/' + pageId, {params: params})
                    .then((response) => {
                        let blocks = [];
                        for (let i = 0; i < response.data.length; ++i) {
                            let block = JSON.parse(response.data[i].content);
                            block.id = response.data[i].id;
                            block.state = response.data[i].state;
                            blocks.push(block);
                        }
                        resolve(blocks);
                    })
                    .catch(reject);
            })
        },
        savePageBlock(context, block) {
            return new Promise((resolve, reject) => {
                this._vm.axios.post('pages/content/', block)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch(reject);
            })
        },
        saveAllBlocks(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.axios.post('pages/content/all', data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch(reject);
            })
        },
        getShippingRates(context, state) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('shipping/rates')
                .then(resolve)
                .catch(reject);
            });
        }
    }
}
